import { http } from '../http'
import { URL } from './_constant'

/**
 * 国有土地项目-列表
 */
export function API_GY_PROJ_LIST(data?: BasicPageReq) {
  return http.post<ApiGyProj.ListRes>(URL.LIST, data)
}

/**
 * 国有土地项目-全部
 */
export function API_GY_PROJ_ALL(data?: BasicPageReq) {
  return http.post<ApiGyProj.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-简单列表
 */
export function API_GY_PROJ_SIMPLE_LIST(data?: BasicPageReq) {
  return http.post<BasicSimpleListItem[]>(URL.SIMPLE_LIST, data)
}
/**
 * 国有土地项目-详情
 */
export function API_GY_PROJ_DETAIL(id: string) {
  return http.post<ApiGyProj.Item>(URL.DETAIL, { id })
}

/**
 * 国有土地项目-新增
 */
export function API_GY_PROJ_ADD(data: ApiGyProj.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 国有土地项目-删除
 */
export function API_GY_PROJ_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  国有土地项目-编辑
 */
export function API_GY_PROJ_EDIT(data: BasicUpdateOneReq<ApiGyProj.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  国有土地项目-禁用
 */
export function API_GY_PROJ_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 国有土地项目-启用
 */
export function API_GY_PROJ_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 国有土地项目-排序
 */
export function API_GY_PROJ_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-导出
 */
export function API_GY_PROJ_EXPORT(data: BasicExportReq) {
  return http.post(URL.EXPORT, data)
}

/**
 * 集体土地项目-统计
 */
export function API_GY_PROJ_TONGJI(data: IdsPayload) {
  return http.post(URL.TONGJI, data)
}

/**
 * 国有土地项目-评估公司设置
 */
export function API_GY_PROJ_APPRAISAL_COMPANY_SET(data: BasicUpdateOneReq<ApiGyProj.AppraisalCompanyData>) {
  return http.post(URL.APPRAISAL_COMPANY_SET, data)
}

/**
 * 国有土地项目-入户评估设置
 */
export function API_GY_PROJ_HOME_ASSESSMENT_SET(data: BasicUpdateOneReq<ApiGyProj.HomeAssessmentData>) {
  return http.post(URL.HOME_ASSESSMENT_SET, data)
}

/**
 * 国有土地项目-预评估公示设置
 */
export function API_GY_PROJ_PRE_ASSESSMENT_NOTICE_SET(data: BasicUpdateOneReq<ApiGyProj.PreAssessmentNoticeData>) {
  return http.post(URL.PRE_ASSESSMENT_NOTICE_SET, data)
}

/**
 * 国有土地项目-资金请批
 */
export function API_GY_PROJ_FUND_APPROVAL_SET(data: BasicUpdateOneReq<ApiGyProj.FundApprovalData>) {
  return http.post(URL.FUND_APPROVAL_SET, data)
}

/**
 * 国有土地项目-房屋拆除
 */
export function API_GY_PROJ_HOUSE_DEMOLITION_SET(data: BasicUpdateOneReq<ApiGyProj.HouseDemolitionData>) {
  return http.post(URL.HOUSE_DEMOLITION_SET, data)
}

/**
 * 国有土地项目-产权证注销
 */
export function API_GY_PROJ_CERT_CANCEL_SET(data: BasicUpdateOneReq<ApiGyProj.CertCancelData>) {
  return http.post(URL.CERT_CANCEL_SET, data)
}

/**
 * 国有土地项目-结项
 */
export function API_GY_PROJ_CLOSURE_SET(data: BasicUpdateOneReq<ApiGyProj.ClosureData>) {
  return http.post(URL.CLOSURE_SET, data)
}

/**
 * 国有土地项目-项目进度设置
 */
export function API_GY_PROJ_PROCESS_SET(data: BasicUpdateOneReq<ApiGyProj.ProcessData>) {
  return http.post(URL.PROCESS_SET, data)
}

/**
 * 国有土地项目-录入-列表
 */
export function API_GY_PROJ_DATA_LIST(data?: BasicPageReq) {
  return http.post<ApiGyProj.ListRes>(URL.DATA_LIST, data)
}

/**
 * 国有土地项目-获取项目下的村庄列表
 */
export async function API_GY_PROJ_VILLAGES_LIST(id: string) {
  const res = await http.post<string[]>(URL.VILLAGES_LIST, { id })
  return res.map(value => ({ value, label: value }))
}
